/**
 * The base type for all messages which are sent over the Messenger.
 */
export abstract class MessageBase {
  /**
   * A unique message tag which identifies the message type.
   */
  abstract tag: string;
}
